// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__XotGP","empty":"ModalGraph_empty__3LdDv"};